module.exports = __webpack_public_path__ + "static/media/banseok.1945fe82.jpg";